import ErrorMessage from "legacy/ErrorMessage"
import {
  capitalizeFirstLetter,
  dollarsToCents,
  handleInputChange,
} from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class EditDiscountsModal extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      showModal: false,
      discountSpace: true,
      discountElectric: false,
      discountType: "dollar",
      amount: "",
      reason: "",
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.save = this.save.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.validator = validatorFactory()
  }

  handleInputChange(event) {
    handleInputChange(this, event)
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  save() {
    if (this.validator.allValid()) {
      this.setState({ saving: true })
      const params = {
        category: this.applyTo(),
        kind: "manual",
        name: this.state.reason,
      }
      if (this.state.discountType === "percent") {
        params.percent_off = this.state.amount / 100
      } else {
        params.total_amount_off = dollarsToCents(this.state.amount)
      }
      this.props.endpoint ? this.ajaxSave(params) : this.embededSave(params)
    } else {
      this.validator.showMessages()
      this.forceUpdate()
    }
  }

  ajaxSave(params) {
    $.post(this.props.endpoint, params, () => {
      location.reload()
    }).fail((data) => {
      this.setState({
        errorMessage: "Error creating discount.",
        saving: false,
      })
    })
  }

  embededSave(params) {
    this.props.addDiscountToForm(params)
    this.closeModal()
    this.setState({ saving: false })
  }

  applyTo() {
    if (this.state.discountSpace && this.state.discountElectric) {
      return "total"
    } else if (this.state.discountElectric) {
      return "electric"
    } else if (this.state.discountSpace) {
      return this.props.spaceCategory
    }
    alert("Select which categories to apply the discount to!")
  }

  render() {
    return (
      <div>
        <button
          type="button"
          className={`btn hidden-print ${this.props.btnClass}`}
          onClick={this.openModal}
          disabled={this.props.disabled}
        >
          Add Discount
        </button>
        {this.props.disabled && (
          <div className="text-muted bs-mt-2">
            Add discounts to a custom rate.
          </div>
        )}
        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="mediumFixed"
        >
          <Modal.Header title="New Discount" />
          <Modal.Body>
            <div className="row nested-row">
              <div className="col-xs-4">
                <label>Apply Discount To</label>
                <div className="checkbox bs-mt-0">
                  <label>
                    <input
                      type="checkbox"
                      name="discountSpace"
                      checked={this.state.discountSpace}
                      onChange={this.handleInputChange}
                    />
                    {capitalizeFirstLetter(this.props.spaceCategory)}
                  </label>
                </div>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      name="discountElectric"
                      checked={this.state.discountElectric}
                      onChange={this.handleInputChange}
                    />
                    Electric
                  </label>
                </div>
                {this.validator.message(
                  "apply_discount_to",
                  this.state.discountSpace || this.state.discountElectric,
                  "accepted"
                )}
              </div>
              <div className="col-xs-5">
                <div className="form-group">
                  <label>Amount</label>
                  <input
                    className="form-control"
                    type="text"
                    name="amount"
                    value={this.state.amount}
                    onChange={this.handleInputChange}
                  />
                  {this.validator.message(
                    "amount",
                    this.state.amount,
                    "required|currency"
                  )}
                </div>
              </div>
              <div className="col-xs-3">
                <div className="form-group bs-mb-0">
                  <label>Unit</label>
                  <select
                    className="form-control"
                    name="discountType"
                    value={this.state.discountType}
                    onChange={this.handleInputChange}
                  >
                    <option value="dollar">Dollars</option>
                    <option value="percent">Percent</option>
                  </select>
                </div>
              </div>
              <div className="col-xs-12">
                <div className="form-group">
                  <label>Discount Reason</label>
                  <textarea
                    className="form-control"
                    type="text"
                    name="reason"
                    value={this.state.reason}
                    onChange={this.handleInputChange}
                  />
                  {this.validator.message(
                    "discount_reason",
                    this.state.reason,
                    "required|min:5"
                  )}
                </div>
              </div>
            </div>
            <ErrorMessage>{this.state.errorMessage}</ErrorMessage>
            {this.props.endpoint && <hr />}
            {this.props.endpoint && (
              <div className="font-semibold text-teal-700">
                Changes to discounts on this reservation will affect the final
                price accordingly.
              </div>
            )}
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText="Apply Discount"
            confirmBtnLoading={this.state.saving}
            onClose={this.closeModal}
            onSubmit={this.save}
          />
        </Modal>
      </div>
    )
  }
}

EditDiscountsModal.propTypes = {
  spaceCategory: PropTypes.string.isRequired,
  endpoint: PropTypes.string,
  btnClass: PropTypes.string,
  disabled: PropTypes.bool,
  addDiscountToForm: PropTypes.func,
}

export default EditDiscountsModal
